import { UniversalAffinitiesStyles } from './UniversalAffinities.types'

const makeStyles = (): UniversalAffinitiesStyles => ({
	affinitiesContainer: {
		backgroundColor: '#FFF0BA',
		display: 'flex',
		fontFamily: 'SVFont',
		fontSize: '24px',
		justifyContent: 'space-between',
		minHeight: '100vh',
		padding: '0px 50px 0px 10px'
	}
})

export default makeStyles
